export const formatDate = (date: Date) => {
  const newDate = new Date(date).toISOString();
  return new Date(newDate).toDateString();
};

export const formatDateTime = (date: Date) => {
  const newDate = new Date(date).toISOString().replace("T", " ");
  return new Date(newDate).toDateString();
};

export const compareDate = (dateInput: Date | string): boolean => {
  const todays_date = new Date("2022-05-12"); // Hardcoded date
  const formatted_date =
    typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  return todays_date > formatted_date;
};
